/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Undo_FailedInputs */

const en_undo_failed = /** @type {(inputs: Undo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not undone.`)
};

/**
* | output |
* | --- |
* | "Not undone." |
*
* @param {Undo_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const undo_failed = /** @type {((inputs?: Undo_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Undo_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_undo_failed(inputs)
});